import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import { ContextGloball } from '../Context/ContextGlobal';
import ItemDetalleSucursal from './ItemDetalleSucursal';
const server = process.env.REACT_APP_SERVER;
const productos = [{ 'ID': 1, 'PRODUCTO': 'POLLO' }, { 'ID': 2, 'PRODUCTO': ' SOBRE PAPA' }, { 'ID': 3, 'PRODUCTO': 'PIPOCA' },
{ 'ID': 4, 'PRODUCTO': 'JUGO' }, { 'ID': 5, 'PRODUCTO': 'ARROZ' }, { 'ID': 6, 'PRODUCTO': 'ARROZ FRIJOL' }, { 'ID': 7, 'PRODUCTO': 'HELADOS' }]

function DetalleHistoricoInv() {
    const { loading, setLoading } = useContext(ContextGloball);
    const [regional, setRegional] = useState(JSON.parse(localStorage.getItem('info')).ID_REGIONAL_ACTUAL);
    const [idUsuario, setIdUsuario] = useState(JSON.parse(localStorage.getItem('info')).ID_EMPLEADO);
    const [fecha, setFecha] = useState('');
    const [sucursales, setSucursales] = useState([]);
    const [actualizar,setActualizar] = useState(false);
    const [idProducto,setIdProducto] = useState(0);
    function obtenerSucursales() {
        if (sucursales.length == 0) {
            setLoading(true);
            fetch(`${server}/sqlComun/getSucursales`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': JSON.parse(localStorage.getItem('__react_session__')).regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    setLoading(false);
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        setSucursales(data.ok)
                    }
                })
                .catch(error => MsgUtils.msgError(error));
        }
    }
    
    useEffect(() => {
        obtenerSucursales()
    }, [])
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                <div className='row row-cols gx-1'>
                    <div className='col' style={{ maxWidth: '170px' }}>
                        <div className="input-group input-group-sm" >
                            <span className="text-light mx-1 my-auto" >Fecha</span>
                            <input type="date" className="form-control"
                                placeholder="Username" title='Elija la Fecha que guste'
                                value={fecha} onChange={(e) => setFecha(e.target.value)} />
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '210px' }}>
                        <div className="input-group input-group-sm" >
                            <span className="text-light mx-1 my-auto" >Producto</span>
                            <select className="form-select" title='Seleccione el producto'
                                value={idProducto} onChange={(e)=>setIdProducto(e.target.value)}>
                                <option value={0}>Ninguno</option>
                                {productos.map((item, index) => {
                                    return (
                                        <option value={item.ID} key={index}>{item.PRODUCTO}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '100px' }}>
                        <button className='btn btn-sm btnNaranja w-100' 
                            title='Obtener Información' 
                            onClick={()=>setActualizar(!actualizar)}>
                                <i className="fa-solid fa-magnifying-glass"></i> Generar
                        </button>
                    </div>
                </div>
            </div>
            <div className='table-responsive'>
                <table className='table table-dark table-striped table-hover'>
                    <thead className='text-center'>
                        <tr>
                            <th>Sucursal</th>
                            <th>Inventario</th>
                            <th>Ingreso</th>
                            <th>Egreso</th>
                            <th>Reserva</th>
                            <th>Traspaso</th>
                            <th>Venta</th>
                            <th>Total</th>
                            <th>Saldo Rep</th>
                            <th>Diferencia</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sucursales.map((item,index)=>{
                            return(
                                <ItemDetalleSucursal sucursal={item} fecha={fecha} 
                                    regional={regional} idProducto={idProducto}
                                    actualizar={actualizar} idUsuario={idUsuario} key={index}/>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default DetalleHistoricoInv